export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20movie%20theater%20interior%20with%20deep%20warm%20red%20velvet%20curtains%20and%20golden%20ambient%20lighting%2C%20rich%20dark%20wood%20paneling%2C%20soft%20warm%20spotlight%20glow%2C%20luxurious%20atmosphere%20with%20art%20deco%20details%2C%20elegant%20theater%20architecture%2C%20empty%20red%20seats%20facing%20forward%2C%20professional%20architectural%20photography%2C%20cinematic%20mood%2C%20high%20detail&width=1920&height=900&seq=hero-bg-wuma-cinema&orientation=landscape"
          alt="午马影院电影殿堂氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-500 text-xs md:text-sm font-medium tracking-wider mb-5">
              海量影片 · 全集播放
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              午马影院 — 最新电影免费在线观看，高清不缓冲秒播
            </h1>

            <p className="text-base md:text-lg text-white/70 font-heading mb-6">
              经典新片一网打尽，尽享流畅观影体验
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              午马影院汇聚海内外最新电影资源，涵盖动作、科幻、喜剧、悬疑、动画等全类型片库。每日同步更新院线新片与经典老片，高清画质搭配智能秒播技术，无需等待缓冲即可畅享沉浸式观影。无论是热门大片全集播放还是小众佳作发掘，午马影院为您打造一站式电影天堂。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                <span>每日更新 30+ 部</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                <span>1080P 高清画质</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                <span>智能秒播不缓冲</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                热播榜单
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[320px] md:max-w-[400px] lg:max-w-[440px]">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary-500/30 via-accent-500/20 to-primary-500/30 rounded-2xl blur-xl"></div>
              <div className="relative rounded-xl overflow-hidden aspect-[2/3] border-2 border-white/15">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20movie%20poster%20collage%20featuring%20dramatic%20film%20scenes%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20epic%20cinematic%20composition%20with%20silhouettes%20and%20atmospheric%20lighting%2C%20film%20reel%20texture%20overlay%2C%20vintage%20cinema%20aesthetic%20with%20modern%20polish%2C%20rich%20contrast%2C%20professional%20movie%20art&width=600&height=900&seq=hero-poster-wuma&orientation=portrait"
                  alt="午马影院精选大片主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}